(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/coupons/coupon-score-parts/score-outcomes-column.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/coupons/coupon-score-parts/score-outcomes-column.js');
"use strict";


const ScoreOutcomesColumn = _ref => {
  let {
    children,
    className
  } = _ref;
  const classNames = ['coupon-score-outcome'];
  if (className) {
    classNames.push(className);
  }
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children);
};
setGlobal('svs.components.sport.quickplayModal2.coupons.CouponScoreParts.ScoreOutcomesColumn', ScoreOutcomesColumn);

 })(window);